var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import moment from 'moment';
import { lastItem, sortedByDescending } from './arrayUtil';
var isEqualAsNumber = function (num1, num2) { return parseInt(num1, 10) === parseInt(num2, 10); };
export var isRecipient = function (conversation, user) { return isEqualAsNumber(conversation.recipient.id, user.id); };
export var isSender = function (conversation, user) { return isEqualAsNumber(conversation.sender.id, user.id); };
/**
 * Retrieves the user
 * */
export var getCurrentUserInConversation = function (conversation, user) {
    if (isSender(conversation, user)) {
        return conversation.sender;
    }
    return conversation.recipient;
};
/**
 * Participant is the other person in a conversation,
 * besides yourself
 * */
export var getParticipant = function (conversation, user) {
    if (isSender(conversation, user)) {
        return conversation.recipient;
    }
    return conversation.sender;
};
var hasSeen = function (lastSeen, createdOn) {
    if (!lastSeen) {
        return false;
    }
    return moment(lastSeen)
        // Some internal threshold to ensure equal timestamps are in
        // the lastSeen's favour
        .add(2, 'millisecond')
        .isAfter(createdOn);
};
export var isMessageRead = function (conversation, message, user) {
    var sender = conversation.sender, recipient = conversation.recipient;
    var createdOn = message.createdOn, senderId = message.senderId;
    // A user has always seen its own message
    if (user.id === senderId) {
        return true;
    }
    if (isSender(conversation, user)) {
        return hasSeen(sender.lastMessageSeen, createdOn);
    }
    return hasSeen(recipient.lastMessageSeen, createdOn);
};
export var isConversationRead = function (conversation, user) {
    var latestMessage;
    if ('latestMessage' in conversation && conversation.latestMessage) {
        // We prefer to use latestMessage, if the field exists
        latestMessage = conversation.latestMessage;
    }
    else if ('messages' in conversation && conversation.messages) {
        latestMessage = lastItem(conversation.messages);
    }
    // Nothing to have read
    if (!latestMessage) {
        return true;
    }
    return isMessageRead(conversation, latestMessage, user);
};
/**
 * Checks if the list of messages contains a certain message.
 * It verifies equality by using each messages' ID.
 * */
var hasMessage = function (message, messages) { return !!messages.find(function (existingMessage) { return existingMessage.id === message.id; }); };
export var mergeMessages = function (oldMessages, messages) {
    var updatedMessages = __spreadArray([], oldMessages);
    messages.forEach(function (message) {
        if (!hasMessage(message, updatedMessages)) {
            updatedMessages.push(message);
        }
    });
    return sortedByDescending(updatedMessages, function (it) { return it.createdOn; });
};
export var updateLastSeenForUser = function (conversation, timeAsIso) {
    var updatedConversation = __assign({}, conversation);
    if (conversation.sender.currentUser) {
        updatedConversation.sender = __assign(__assign({}, updatedConversation.sender), { lastMessageSeen: timeAsIso });
    }
    else if (conversation.recipient.currentUser) {
        updatedConversation.recipient = __assign(__assign({}, updatedConversation.recipient), { lastMessageSeen: timeAsIso });
    }
    return updatedConversation;
};
